import { Store } from "pullstate";

import { ISignup } from "types/IAuth";

const defaultSignup = {} as ISignup;

export const SignupState = new Store(defaultSignup);
